/**
 * V2 Testimonials — Swiper carousel
 * Figma: section-testimonials (node 245:3546)
 */
(function () {
  const SECTION_SELECTOR = '[data-v2-testimonials]';
  const DESKTOP_MQ = '(min-width: 900px)';

  function initTestimonials(root) {
    if (!root || root.dataset.v2TestimonialsReady === 'true') return;
    if (typeof Swiper === 'undefined') return;

    const swiperEl = root.querySelector('[data-v2-testimonials-swiper]');
    const slides = root.querySelectorAll('.swiper-slide');
    const slideCount = slides.length;
    if (!swiperEl || slideCount === 0) return;

    root.dataset.v2TestimonialsReady = 'true';

    const loopRequested = root.dataset.loop === 'true';
    const prevEl = root.querySelector('[data-v2-testimonials-prev]');
    const nextEl = root.querySelector('[data-v2-testimonials-next]');
    const hasNav = Boolean(prevEl && nextEl);

    // Swiper loop needs more slides than slidesPerView (3 on desktop)
    const canLoop = loopRequested && slideCount > 3;

    let swiper = null;

    function buildOptions() {
      // 16px = spacing/4 — Figma gap between cards at every breakpoint
      // Desktop: 276 + 16 + 276 + 16 + 276 = 860
      const cardGap = 16;

      const options = {
        slidesPerView: 'auto',
        spaceBetween: cardGap,
        speed: 400,
        watchOverflow: true,
        centerInsufficientSlides: true,
        loop: canLoop,
        allowTouchMove: slideCount > 1,
        simulateTouch: slideCount > 1,
        grabCursor: slideCount > 1,
        threshold: 5,
        breakpoints: {
          900: {
            slidesPerView: 3,
            spaceBetween: cardGap,
            slidesPerGroup: 1,
            allowTouchMove: slideCount > 3 || canLoop,
            simulateTouch: slideCount > 3 || canLoop,
            grabCursor: slideCount > 3 || canLoop,
          },
        },
      };

      if (hasNav) {
        options.navigation = {
          prevEl: prevEl,
          nextEl: nextEl,
          disabledClass: 'swiper-button-disabled',
        };
      }

      if (!canLoop) {
        options.loop = false;
        // Disable at ends when not looping (Swiper handles via navigation + watchOverflow)
        options.rewind = false;
      }

      return options;
    }

    swiper = new Swiper(swiperEl, buildOptions());

    function syncNavVisibility() {
      if (!hasNav) return;
      const isDesktop = window.matchMedia(DESKTOP_MQ).matches;
      const show = isDesktop && slideCount > 3;
      prevEl.hidden = !show;
      nextEl.hidden = !show;
      prevEl.setAttribute('aria-hidden', show ? 'false' : 'true');
      nextEl.setAttribute('aria-hidden', show ? 'false' : 'true');
    }

    syncNavVisibility();

    const mq = window.matchMedia(DESKTOP_MQ);
    function onBreakpointChange() {
      syncNavVisibility();
    }
    if (typeof mq.addEventListener === 'function') {
      mq.addEventListener('change', onBreakpointChange);
    } else if (typeof mq.addListener === 'function') {
      mq.addListener(onBreakpointChange);
    }

    root._v2TestimonialsDestroy = function destroy() {
      if (typeof mq.removeEventListener === 'function') {
        mq.removeEventListener('change', onBreakpointChange);
      } else if (typeof mq.removeListener === 'function') {
        mq.removeListener(onBreakpointChange);
      }
      if (swiper && typeof swiper.destroy === 'function') {
        swiper.destroy(true, true);
      }
      delete root.dataset.v2TestimonialsReady;
      delete root._v2TestimonialsDestroy;
    };
  }

  function initAll() {
    document.querySelectorAll(SECTION_SELECTOR).forEach(initTestimonials);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.querySelector(SECTION_SELECTOR) || event.target.closest(SECTION_SELECTOR);
    if (root) initTestimonials(root);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    const root = event.target.querySelector(SECTION_SELECTOR) || event.target.closest(SECTION_SELECTOR);
    if (root && typeof root._v2TestimonialsDestroy === 'function') {
      root._v2TestimonialsDestroy();
    }
  });

  if (typeof Swiper === 'undefined') {
    const retry = window.setInterval(() => {
      if (typeof Swiper !== 'undefined') {
        window.clearInterval(retry);
        initAll();
      }
    }, 50);
    window.setTimeout(() => window.clearInterval(retry), 5000);
  }
})();
